import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import Layout from "@/layout";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "../store";

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/training",
    children: [
      {
        path: "/home",
        component: () => import("@/views/home/index"),
        name: "Home",
        meta: { title: "首页", icon: "home", affix: true },
      },
      // 课程
      {
        path: "/course/:id",
        component: () => import("@/views/course/index2"),
        name: "Course",
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/course2",
        component: () => import("@/views/course/index2"),
        name: "Course2",
      },
      {
        path: "/course",
        component: () => import("@/views/course/list"),
        name: "List",
      },
      // 实训管理
      {
        path: "/training",
        component: () => import("@/views/training/index"),
        name: "Training",
      },
      // 商品详情
      {
        path: "/goods/:id",
        component: () => import("@/views/goods/detail"),
        name: "Goods",
        meta: {
          isPublic: true,
        },
      },
      // 购物车
      {
        path: "/order/cart",
        component: () => import("@/views/order/cart"),
        name: "ShoppingCart",
      },
      // 支付
      {
        path: "/order/pay",
        component: () => import("@/views/order/pay"),
        name: "Pay",
      },
      // 实训管理
      {
        path: "/exam",
        component: () => import("@/views/exam/index"),
        name: "Exam",
      },
      // 个人中心
      {
        path: "/profile",
        component: () => import("@/views/profile/index"),
        name: "Profile",
      },
      // 消息中心
      {
        path: "/message",
        component: () => import("@/views/message/index"),
        name: "Message",
      },
      {
        path: "/message/:id",
        component: () => import("@/views/message/index"),
        name: "Message",
      },
    ],
  },
  // 课程详细
  {
    path: "/read/:id",
    component: () => import("@/views/read/index"),
    name: "Read",
    meta: {
      isPublic: true,
    },
  },
  // 考试系统
  {
    path: "/testing/:id",
    component: () => import("@/views/testing/index"),
    name: "Testing",
  },
  // 考试成绩
  {
    path: "/results/:id",
    component: () => import("@/views/results/index"),
    name: "Results",
  },

  {
    path: "/oidc-callback",
    component: () => import("@/views/oidc/oidc-callback"),
    hidden: true,
  },
  {
    path: "/logout",
    component: () => import("@/views/oidc/logout"),
    hidden: true,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: "/444",
    component: () => import("@/views/error/444"),
  },
  {
    path: '/:path(.*)*',
    redirect: '/404',
    name: '404Page',
    meta: {
      hidden: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;

router.beforeEach(vuexOidcCreateRouterMiddleware(store, "oidc"));

router.beforeEach(async (to, from, next) => {
  // start progress bar
  //NProgress.start()

  // set page title
  //document.title = getPageTitle(to.meta.title)

  const hasToken = store.getters['oidc/oidcAccessToken']
  if (hasToken) {

    

    const roles = store.getters["user/roles"];
    // console.log((roles.length > 0) & !roles.includes("Student"), roles);
    if ((to.path !== "/444") & (roles.length > 0) & !roles.includes("Student")) {
      //window.location.href = process.env.VUE_APP_TEACHER_WEBSITE
      console.log(to.path);
      if (to.path.includes('/read/') || to.path.includes('/course/')) {
        next()
      }
      else {
        next("444")
      }
    }

    const hasRoles = roles && roles.length > 0
    if (hasRoles) {
      next()
    }
    else {
      await store.dispatch('user/getInfo')
      next({ ...to, replace: true })
    }
  }
  else {
    next()
  }

  
});
